export enum AdminTenantRole {
  user = "user",
}

export type AdminUserType = "client" | "tellus";

export interface AdminUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: AdminTenantRole;
  userType: AdminUserType;
  position: string | null;
  department: string | null;
}
